import React from 'react'
import { logToDatadog } from './services/datadog';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Grid } from '@mui/material';

interface ErrorBoundaryProps extends React.PropsWithChildren {}
interface ErrorBoundaryState {
  hasError: boolean;
}
export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
      super(props);
      this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
      if (process.env.NODE_ENV === "production") {
        logToDatadog("error_boundary", { error, errorInfo }, "error")
      }
    }

    render() {
      if (this.state.hasError) {
        return (
            <div className="error-boundary-container">
                <Grid container spacing={1}>
                    <Grid item>
                        <ErrorOutlineIcon fontSize="large" color="error" />
                    </Grid>
                    <Grid item>
                        <h1>Whoops something went wrong...</h1>
                    </Grid>
                </Grid>
                <h4>
                    Our development team has been sent the error
                    report and will fix the problem shortly, please refresh the page.
                </h4>
            </div>

        )
      }

      return this.props.children;
    }
}
